import axios from "axios";
import { api } from "./api_route";

export const createCommunication = async (data) => {
  try {
    const response = await axios.post(`${api}/communication/create`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCommunication = async (data) => {
  try {
    const response = await axios.post(`${api}/communication/update`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCommunication = async (data) => {
  try {
    const response = await axios.post(`${api}/communication/get`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCommunication = async (data) => {
  try {
    const response = await axios.post(`${api}/communication/delete`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
